<fullscreen-page>
  <content-column look="dark">

    <div class="h-100 p-3" slot="content">
      <dx-scroll-view [useNative]="true">
        <dx-toolbar class="applicationbar light" height="68" id="toolbar">

          <dxi-item locateInMenu="never" location="before" widget="dxButton">
            <div *dxTemplate>
              <a [routerLink]="['/catalogs']">
                <img alt="nextPim Pim System" height="55" src="{{logoUrl}}" style="margin-left: 6px"/>
              </a>
            </div>
          </dxi-item>
          <dxi-item *ngIf="currentNavigationTitle" locateInMenu="never" location="center" widget="dxButton">
            <div *dxTemplate>
              <div class="d-flex flex-row justify-content-center">
                <div>{{ currentAccount }}</div>
              </div>
              <div class="d-flex flex-row justify-content-center">
                <div>
                  <h6>{{ currentNavigationTitle }}</h6>
                </div>
              </div>
            </div>
          </dxi-item>
        </dx-toolbar>
        <div class="d-block h-100 w-100 mx-auto " style="max-width: 1200px;">

          <div class="d-flex flex-row">
            <div class="flex-fill pr-3 w-50">
              <form (submit)="onRegistration()">
                <dx-form [formData]="registerUser">
                  <dxi-item [colCount]="2" caption="{{ 'Registrierung' | translate }}" itemType="group">
                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.firstName" [showClearButton]="true"
                                     label="{{ 'Vorname' | translate }}"
                                     width="100%">
                          <dx-validator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie Ihren Vornamen ein' | translate }}."
                                                 type="required"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.lastName" [showClearButton]="true"
                                     label="{{ 'Nachname' | translate }}"
                                     width="100%">
                          <dx-validator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie Ihren Nachnamen ein' | translate }}."
                                                 type="required"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.accountName" [showClearButton]="true"
                                     label="{{ 'Name des Accounts (Name des Unternehmens)' | translate }}"
                                     width="100%">
                          <dx-validator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie einen Accountnamen an' | translate }}."
                                                 type="required"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.mail" [showClearButton]="true"
                                     label="{{ 'Email' | translate }}"
                                     width="100%">
                          <dx-validator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie Ihre Emailadresse ein' | translate }}."
                                                 type="required"></dxi-validation-rule>
                            <dxi-validation-rule
                              message="{{ 'Bitte geben Sie eine gültige Emailadresse ein' | translate }}."
                              type="email"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.password" [showClearButton]="true"
                                     label="{{ 'Passwort' | translate }}"
                                     mode="password" width="100%">
                          <dx-validator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie Ihr Passwort ein' | translate }}."
                                                 type="required"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [showClearButton]="true" label="{{ 'Passwort wiederholen' | translate }}"
                                     mode="password"
                                     width="100%">
                          <dx-validator #targetValidator>
                            <dxi-validation-rule message="{{ 'Bitte geben Sie Ihr Passwort erneut ein' | translate }}."
                                                 type="required"></dxi-validation-rule>
                            <dxi-validation-rule [comparisonTarget]="passwordComparison"
                                                 message="{{ 'Passwörter stimmen nicht überein' | translate }}."
                                                 type="compare"></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.street" [showClearButton]="true"
                                     label="{{ 'Straße' | translate }}"
                                     width="100%"></dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.city" [showClearButton]="true"
                                     label="{{ 'Stadt' | translate }}"
                                     width="100%"></dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item>
                      <div *dxTemplate>
                        <dx-text-box [(value)]="registerUser.zipCode" [showClearButton]="true"
                                     label="{{ 'Postleitzahl' | translate }}"
                                     width="100%"></dx-text-box>
                      </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                      <div *dxTemplate>
                        <dx-select-box (onValueChanged)="onLicenseChanged()"
                                       [(value)]="registerUser.pimLicense"
                                       [items]="licenses"
                                       [readOnly]="registerUser.linkedCustomerId"
                                       displayExpr="identifier"
                                       label="{{ 'Lizenz' | translate }}"
                                       valueExpr="id"
                                       width="100%">
                        </dx-select-box>
                      </div>
                    </dxi-item>
                  </dxi-item>


                </dx-form>
                <dx-validation-summary id="summary"></dx-validation-summary>

                <div class="dx-field d-flex flex-row">
                  <dx-button [useSubmitBehavior]="true" stylingMode="text" text="{{ 'Registrieren' | translate }}"
                             type="default"></dx-button>
                </div>
              </form>
            </div>
            <div class="flex-fill pr-3 w-50">
              <div><h6>{{ 'Ansprechpartner' | translate }}</h6></div>
              <dx-accordion [collapsible]="false"
                            [dataSource]="contacts"
                            [multiple]="true"
                            [selectedItems]="contacts"
                            style="padding-top:30px">
                <div *dxTemplate="let contact of 'title'">
                  <div class="header">{{ contact.contactName }}</div>
                </div>
                <div *dxTemplate="let contact of 'item'">
                  <div class="d-flex flex-row">
                    <div class="w-50">
                      <p *ngIf="contact.contactName">
                        <b>{{ 'Name' | translate }}:</b> {{ contact.contactName }}
                      </p>
                      <p *ngIf="contact.contactEmail">
                        <b>{{ 'E-Mail' | translate }}:</b> {{ contact.contactEmail }}
                      </p>
                      <p *ngIf="contact.contactPhone">
                        <b>{{ 'Telefon' | translate }}:</b> {{ contact.contactPhone }}
                      </p>
                      <p *ngIf="contact.domain">
                        <b>{{ 'Webseite' | translate }}:</b>
                        <a href="{{ contact.domain }}" target="_blank">
                          {{ contact.domain }}
                        </a>
                      </p>
                    </div>
                    <div class="w-50 d-flex justify-content-center align-items-center">
                      <div style="max-width: 240px; overflow: visible;">
                        <img [src]="contact.logoUrl"
                             alt="image"
                             style="width: 100%; height: auto;">
                      </div>
                    </div>
                  </div>
                </div>
              </dx-accordion>

            </div>
          </div>
        </div>
      </dx-scroll-view>
    </div>
  </content-column>
</fullscreen-page>
